export default "__VITE_ASSET__B5Fi7qKr__"